// extracted by mini-css-extract-plugin
export var dropdown = "_r7-0";
export var imageWrapper = "_r7-3";
export var itemNameContainer = "_r7-1";
export var productImage = "_r7-2";
export var spinnerWrapper = "_r7-4";